import { useTranslation } from "react-i18next";

export function ChecklistItemGuidance({ guidance, className = "" }) {
  const { t } = useTranslation();
  const text = String(guidance || "").trim();
  if (!text) return null;

  return (
    <div
      className={`rounded-md border border-sky-100 bg-sky-50/90 px-2.5 py-2 text-xs sm:text-sm text-sky-950 ${className}`}
    >
      <p className="text-[10px] sm:text-[11px] font-semibold uppercase tracking-wide text-sky-800">
        {t("quality.checklist.item.guidanceTitle")}
      </p>
      <p className="mt-1 whitespace-pre-wrap leading-relaxed">{text}</p>
    </div>
  );
}
